import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-divider"></div>
      <div className="footer-inner">
        <section>
          <p>Vinayaka Enterprises Paints brings vibrant, long-lasting coatings for homes and professionals. Our eco-friendly formulas deliver premium coverage, rich hues, and superior durability.</p>
          <p>From interior finishes to exterior weatherproof solutions, we help you paint with confidence and creativity.</p>
        </section>
        <section>
          <h4>Quick Contacts</h4>
          <ul className="list">
            <li><a href="tel:+91 9677657643">Call: +91 9677657643</a></li>
            <li><a href="mailto:sk5779601@gmail.com">Email: sk5779601@gmail.com</a></li>
          </ul>
          <h4>Social</h4>
          <ul className="list">
            <li><a href="https://www.instagram.com/srivinayakaenterprises18?igsh=MW1rd3I3dnpnbjRiaA==">Instagram</a></li>
          </ul>
        </section>
        <section>
          <h4>Locations</h4>
          <ul className="list">
            <li> <a href="https://maps.app.goo.gl/AQugzM2YhGT8s6rG6?g_st=iw">Madurai, Teppakulam</a></li>
            <li><a href=" https://maps.app.goo.gl/eRYAEnu9kMe3f3dh7?g_st=iw">Sivaganga, Thirupuvanam</a></li>
            <li><a href=" https://maps.app.goo.gl/JCHM3Bwvcdvdehtz7?g_st=iw">Sivaganga, Karaikudi</a></li>
          </ul>
        </section>
      </div>
      <div className="footer-bottom">
        <div className="footer-logo">Sri Vinayaka Enterprises</div>
        <div className="rights">© {year} Sri Vinayaka Enterprises — All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;